import { AUTO_TRADER_PUBLISHER } from '../builders/core';
export class VideoBuilder {
    constructor(name) {
        this.withDescription = (description) => {
            this.description = description;
            return this;
        };
        this.withUploadDate = (uploadDate) => {
            this.uploadDate = uploadDate;
            return this;
        };
        this.withDuration = (duration) => {
            this.duration = duration;
            return this;
        };
        this.withEmbedUrl = (embedUrl) => {
            this.embedUrl = embedUrl;
            return this;
        };
        this.withThumbnailUrl = (thumbnailUrl) => {
            this.thumbnailUrl = thumbnailUrl;
            return this;
        };
        this.build = () => {
            return {
                '@context': 'https://schema.org',
                '@type': 'VideoObject',
                name: this.name,
                description: this.description,
                uploadDate: this.uploadDate,
                duration: this.duration,
                embedUrl: this.embedUrl,
                thumbnailUrl: this.thumbnailUrl,
                publisher: AUTO_TRADER_PUBLISHER,
            };
        };
        this.name = name;
    }
}
VideoBuilder.aBuilder = (name) => {
    return new VideoBuilder(name);
};
